import { render, staticRenderFns } from "./mai.vue?vue&type=template&id=060be180&scoped=true&"
import script from "./mai.vue?vue&type=script&lang=ts&"
export * from "./mai.vue?vue&type=script&lang=ts&"
import style0 from "./mai.vue?vue&type=style&index=0&id=060be180&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060be180",
  null
  
)

export default component.exports